export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">关于色影视</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-2xl mx-auto">
            以技术驱动观影体验，让每一个爱追剧的人都能享受不缓冲的高清流畅播放
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-background-100 rounded-xl p-6 border border-background-200/70 text-center">
            <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center mx-auto mb-4">
              <i className="ri-eye-line text-xl text-primary-500"></i>
            </div>
            <h3 className="text-lg font-bold text-foreground-950 font-heading mb-2">我们的愿景</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              让优质影视内容触手可及，打破地域与设备的限制，为中文用户打造最流畅的在线观影平台。
            </p>
          </div>
          <div className="bg-background-100 rounded-xl p-6 border border-background-200/70 text-center">
            <div className="w-12 h-12 rounded-xl bg-accent-500/10 flex items-center justify-center mx-auto mb-4">
              <i className="ri-database-2-line text-xl text-accent-500"></i>
            </div>
            <h3 className="text-lg font-bold text-foreground-950 font-heading mb-2">内容生态</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              15000+影视作品收录，电视剧、电影、综艺、动漫、纪录片五大品类，每日持续更新扩充。
            </p>
          </div>
          <div className="bg-background-100 rounded-xl p-6 border border-background-200/70 text-center">
            <div className="w-12 h-12 rounded-xl bg-secondary-500/10 flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-xl text-secondary-500"></i>
            </div>
            <h3 className="text-lg font-bold text-foreground-950 font-heading mb-2">品质承诺</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              全站HTTPS加密，无恶意弹窗，纯净观影环境。持续优化播放技术，保障流畅体验。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}